import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["rows", "template", "position", "destroy"]
  static values = { nextIndex: Number, confirm: String }

  add() {
    const index = this.nextIndexValue++
    this.rowsTarget.insertAdjacentHTML("afterbegin", this.templateTarget.innerHTML.replaceAll("NEW_RECORD", index))
    this.updatePositions()
  }

  remove(event) {
    if (!window.confirm(this.confirmValue)) return

    const row = event.currentTarget.closest("[data-specifications-target='row']")
    row.querySelector("[data-specifications-target='destroy']").value = "1"
    row.hidden = true
    this.updatePositions()
  }

  dragStart(event) {
    this.draggedRow = event.currentTarget
    this.draggedRow.classList.add("is-dragging")
    event.dataTransfer.effectAllowed = "move"
  }

  dragEnd() {
    this.draggedRow?.classList.remove("is-dragging")
    this.rowsTarget.querySelectorAll(".is-drop-target").forEach((row) => row.classList.remove("is-drop-target"))
    this.draggedRow = null
  }

  dragOver(event) {
    event.preventDefault()
    const row = event.currentTarget
    if (row !== this.draggedRow) {
      row.classList.add("is-drop-target")
      row.parentNode.insertBefore(this.draggedRow, row)
    }
  }

  drop(event) {
    event.preventDefault()
    event.currentTarget.classList.remove("is-drop-target")
    this.updatePositions()
  }

  updatePositions() {
    this.positionTargets.forEach((input, index) => { input.value = index })
  }
}
